import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';

type ShowMoreProps = {
  list: string[];
  limit?: number;
  delimiter?: string;
};

const ShowMore = ({
  list = [],
  limit = 10,
  delimiter = ', ',
}: ShowMoreProps) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <div>
      <span>{list.slice(0, limit).join(delimiter)}</span>
      {list.length > limit && (
        <span>{T.translate('OTHERS', { context: list.length - limit })}</span>
      )}
    </div>
  );
};

ShowMore.displayName = 'ShowMore';

ShowMore.propTypes = {
  /** list of items to display  */
  list: PropTypes.array,
  /** size of items displayed */
  limit: PropTypes.number,
  /** delimiter between items */
  delimiter: PropTypes.string,
};

export default ShowMore;
